import { render, staticRenderFns } from "./guest_sx002.vue?vue&type=template&id=4dedb1d4&scoped=true"
import script from "./guest_sx002.vue?vue&type=script&lang=js"
export * from "./guest_sx002.vue?vue&type=script&lang=js"
import style0 from "./guest_sx002.vue?vue&type=style&index=0&id=4dedb1d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dedb1d4",
  null
  
)

export default component.exports